import { Button } from "@nextui-org/react";
import React from 'react';
import {useLoaderData } from 'react-router-dom';
import { Container, Table, Text, Col, Row} from "@nextui-org/react";

function DownloadZipBtn(params) {

    const fileName = params.fileName
    const handler = params.onCusPress
    const click = () => {
        handler(fileName)
    }

    return (<Col>
        <Row>
            <Button auto onPress={click}>下载</Button>
        </Row>
    </Col>);
}

export  function ConfusedListPage(params) {

    const { rows, owner, repo } = useLoaderData()
    console.log(rows,owner,repo)
    if (rows == null || rows.length ==undefined || rows.length <= 0) {
        return (<div>
            <h1>Fail</h1>
        </div>);
    }
    const downloadPress = (fName) => {
        console.log(fName)
        //http://162.243.171.183:8022/download/futuretimeinc/mac_screen_recorder_James/futuretimeinc_mac_screen_recorder_James_master_2023_05_06_17_12_44.zip
        const url = "http://162.243.171.183:8022/download/"+owner+"/"+repo+"/"+fName
        const eleLink = document.createElement('a');
        eleLink.style.display = 'none';
        // eleLink.target = "_blank"
        eleLink.href = url;
        // eleLink.href = record;
        document.body.appendChild(eleLink);
        eleLink.click();
        document.body.removeChild(eleLink);
    }

    const renderCell = (item, pKey) => {
        var value = item.key
        switch (pKey) {
            case "name":
                return (<Col>
                    <Row>
                        <Text b size={14} css={{ tt: "capitalize" }}>
                            {value}
                        </Text>
                    </Row>
                </Col>);
            case "action":
                return (<DownloadZipBtn onCusPress={downloadPress} fileName={value}></DownloadZipBtn>);
            default:
                return (<div></div>);
        }
    }
    const columns = [
        {
            key: "name",
            label: "Name",
        },
        {
            key: "action",
            label: "Action",
        }
    ];

    return (
        <Container>
            <Table
                css={{
                    height: "auto",
                    minWidth: "100%",
                }}
            >
                <Table.Header columns={columns}>
                    {(column) => (
                        <Table.Column key={column.key}>{column.label}</Table.Column>
                    )}
                </Table.Header>
                <Table.Body items={rows}>
                    {(item) => (
                        <Table.Row>
                            {(columnKey) => (
                                <Table.Cell>{renderCell(item, columnKey)}</Table.Cell>
                            )}
                        </Table.Row>
                    )}
                </Table.Body>
            </Table>
        </Container>
    );

}

export async function loader({ params }) {
    var resp = await fetch('http://162.243.171.183:8022/confuselist', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            owner: params.owner,
            repo: params.repo
        })
    })
    if (resp.status != 200) {
        return {
            rows: null,
            owner: params.owner,
            repo: params.repo
        }
    }
    var res = await resp.json()
    console.log(res)
    return {
        rows: res,
        owner: params.owner,
        repo:params.repo
    }
}

export default ConfusedListPage;